import objectFitImages from 'object-fit-images'
window.addEventListener('load', function(){
  objectFitImages()
})
